import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist or has been moved." noindex />
    <section className="min-h-[60vh] flex items-center justify-center bg-white">
      <div className="max-w-md text-center px-6">
        <p className="font-display text-7xl font-bold" style={{ color: "var(--brand-700)" }}>404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-brand" style={{ color: "var(--brand-700)" }}>Page not found</h1>
        <p className="mt-3 text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/">
          <Button className="mt-6 text-white" style={{ backgroundColor: "var(--brand-700)" }}>
            <Home size={15} className="mr-2" /> Back to Home
          </Button>
        </Link>
      </div>
    </section>
    </>
  );
}
